import styled from 'styled-components';
import appTheme from '../../../themes/Theme';
import TextField from '@material-ui/core/TextField';

export const StyledRadiusInput = styled(TextField)`
  && {
    min-width: 80px;
    height: 60px;
    left: 50%;
    transform: translateX(-50%);
  }
  & label, label.Mui-focused{
    color: ${(props) => props.error ? '#f44336' : '#38c2a0'};
  }
  & label.MuiFormLabel-root.Mui-disabled{
    color: grey;
  }
  & div.Mui-focused > fieldset.MuiOutlinedInput-notchedOutline{
    border-color: ${(props) => props.error ? '#f44336' : '#38c2a0'}; 
  }

  & div.MuiOutlinedInput-root:hover > fieldset.MuiOutlinedInput-notchedOutline{
    border-color: ${(props) => props.error ? '#f44336' : '#38c2a0'}; 
  }

  & fieldset.MuiOutlinedInput-notchedOutline{
    border-color: ${(props) => props.error ? '#f44336' : '#38c2a0'};
  }
  & > div.Mui-disabled > fieldset.MuiOutlinedInput-notchedOutline{
    border-color: grey;
  }
  & input{
    color: ${(props) => props.error ? '#f44336' : appTheme.textColor};
  }
`;